import { getCookie, setAuthCookies } from "../../../../utils/cookies";
import { OnboardingActionTypes } from "../../../action-types";

export const updateUserStatus = (status) => async (dispatch) => {
    const user = getCookie("user");
    setAuthCookies("user", { ...user, status })
  dispatch({
    type: OnboardingActionTypes.UPDATE_CLIENT_STATUS,
    payload: { status },
  });
};
